import { Column } from "ag-grid-community";
import { Cell, Row, Worksheet } from "exceljs";
import { FeiKeyDef } from "@wizeoo/akm-compute-lib";
import { FreedataValueVO } from "../../vo/core/freedatavalue.vo";
import { ChronocodeVO } from "../../vo/core/chronocode.vo";

// params de modification en cascade
export interface ExcelColumn  {
  key: string; // libellé / code de la colonne
  column: Column; // colonne agGrid
  fkd: FeiKeyDef; // def de colonne
  field: string; // champ (FD/ chrono)
  fdvs?: Map<string, FreedataValueVO>; // si FD, mémorisation des valeurs pour accès rapide, map sur la base du wcio
  chrons?: Map<string, ChronocodeVO>; // si chrono, mémorisation des valeurs pour accès rapide, map sur la base du wcio
}

/**
 * encapsulation des lignes d'import excel
 */
export class ExcelSheetVo {
  
  private _sheet: Worksheet = null;
  
  /** les entêtes, ordonnées */
  public rawHead: string[] = null;

  // les lignes
  public rawRows: Row[] = [];

  constructor() {
  }

  public build(pSheet: Worksheet): void {
    this._sheet = pSheet;
    this.rawHead = [];
    this._sheet.eachRow((row: Row, rowNumber: number) => {
      if(rowNumber === 1) { 
        row.eachCell((cell: Cell, colNumber: number) => {
          this.rawHead.push(cell.value.toString());
        });
        // console.log('Row: ' + rowNumber + ' Value: ' + row.values);
      }  else {
        this.rawRows.push(row);
      }   
    });
  }


}
